import { PrimeIcons } from 'primereact/api';

import { Permission } from '../../model/enumeration/Permission.enum';
import permissionStore from '../../store/PermissionStore';
import { Paths } from '../Router/Paths';

export const getDashboardNodes = (): any => [
  {
    key: 'dashboard',
    label: 'Dashboard',
    children: [
      {
        id: Paths.MANAGE_ACCOUNTS,
        className: 'dashboard-child-node',
        key: 'manage-accounts',
        label: 'Manage users',
        icon: PrimeIcons.USERS,
        permissions: [Permission.MANAGE_ACCOUNTS],
      },
      {
        id: Paths.MANAGE_BOT_SEATING,
        key: 'manage-bot-seating',
        className: 'dashboard-child-node',
        label: 'Manage account seating',
        icon: PrimeIcons.USER_PLUS,
        permissions: [Permission.MANAGE_BOTS_SEATING],
      },
      {
        id: Paths.MANAGE_BOT_PARAMS,
        key: 'manage-bot-params',
        className: 'dashboard-child-node',
        label: 'Manage account params',
        icon: PrimeIcons.SLIDERS_H,
        permissions: [
          Permission.MANAGE_BOTS_PARAMS,
          Permission.CHANGE_BOTS_CLUBS,
          Permission.RESET_BOTS_RESTRICTIONS,
        ],
      },
    ].filter(node =>
      node.permissions.some(permission =>
        permissionStore.hasPermission(permission),
      ),
    ),
  },
];
